import React from 'react';
import { Col, ColProps } from 'react-bootstrap';

interface SectionContainerProps {
    hasLayout?: boolean;
    children: React.ReactNode;
}

export const SectionContainer: React.FC<SectionContainerProps> = ({ hasLayout, children }) => {
    const sizes: ColProps = hasLayout ? { xs: 12 } : { xs: 12, md: { span: 6, offset: 3 }, lg: 7 };

    return (
        <Col {...sizes}>
            {children}
        </Col>
    );
};